import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  makeStyles,
  Typography,
  useTheme,
  TextField,
  TablePagination,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import styles from "../../styles/global-styles";
import { connect } from "react-redux";
import { actions } from "../../redux/actions/shoppingCart";
import { actions as actionsAlert } from "../../redux/actions/alert";
import CategorySelect from "../../components/shared/selects/CategorySelect";
import { AuthService } from "../../services/auth.service";
import { ProductService } from "../../services/product.service";
import MovileCard from "../../components/core/sells/MovileCard";
import AccesoryCard from "../../components/core/sells/AccesoryCard";
import { changeRowsPerPage } from "../../_utils/utils";
import BackDrop from "../../components/shared/backdrop/Backdrop";

const useStyles = makeStyles((theme) => ({
  title: { color: "#1C2668", fontWeight: 600 },
  rightButton: styles.buttonRightHeader,
}));

const ContainerNewSell = ({
  addAlert,
  detailAlert,
  addToCart,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [searchProduct, setSearchProduct] = useState("");
  const [queryParams, setqueryParams] = useState({});
  const [productFoundArray, setProductsFoundArray] = useState([]);
  const [productsAvailable, setProductsAvailable] = useState(undefined);
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    const { siteId } = AuthService.currentUserValue;
    setqueryParams({
      ...queryParams,
      siteId,
      inDistribution: 0,
      productSold: 0,
    });
    if (!siteId) {
      setTimeout(() => {
        AuthService.logout();
      }, 25000);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message:
          "No se puede recuperar las garantías de la sucursal que solicitaste",
      });
    }
  }, []);

  useEffect(() => {
    if (productFoundArray.length) {
      console.log("enter here");
      setProductsAvailable(true);
    }
  }, [productFoundArray]);

  const handleChange = ({ target: { value } }) => {
    const valuesForSearch = value.split(",");
    setqueryParams({
      ...queryParams,
      brand: valuesForSearch[0],
      model: valuesForSearch[1] || "",
      color: valuesForSearch[2] || "",
    });
    setSearchProduct(value);
  };

  const handleCategorySelected = (key, value) =>
    setqueryParams({ ...queryParams, [key]: value });

  const handleSearchProducts = async () => {
    setProductsAvailable(false);
    setProductsFoundArray([]);
    const { siteId } = AuthService.currentUserValue;
    const noProductFound = {
      noProduct:
        "No se encontró ningún producto, modificar filtros de búsqueda",
    };
    setPage(0);
    const { brand, model, color, productTypeId } = queryParams;
    /** remove spaces */
    const body = {
      brand: brand ? brand.trim() : brand,
      model: model ? model.trim() : model,
      color: color ? color.trim() : color,
      productTypeId,
      siteId,
      productSold: 0,
    };

    try {
      if (!body.productTypeId) {
        console.log("query params", body);
        const { data } = await ProductService.getProductByMovilesWithParams(
          body
        );
        const accesoriesData =
          await ProductService.getProductByAccesoriesWithParams(body);
        if (!data.length && !accesoriesData.data.length) {
          throw noProductFound;
        }
        setProductsFoundArray([...data, ...accesoriesData.data]);
      } else if (queryParams.productTypeId === 1) {
        const { data } = await ProductService.getProductByMovilesWithParams(
          body
        );
        if (!data.length) {
          throw noProductFound;
        } else setProductsFoundArray(data);
      } else if (queryParams.productTypeId === 2) {
        const { data } = await ProductService.getProductByAccesoriesWithParams(
          body
        );
        if (!data.length) {
          throw noProductFound;
        } else setProductsFoundArray(data);
      }
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.noProduct ? "warning" : "error",
        message: error.noProduct ? error.noProduct : error.msgs,
      });
      setProductsAvailable(true);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  return (
    <React.Fragment>
      <Grid container>
        <Typography variant="h4" component="h4" className={classes.title}>
          Artículos (equipo móvil o accesorio)
        </Typography>
      </Grid>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={10}
      >
        <Grid item>
          <TextField
            variant="outlined"
            value={searchProduct}
            onChange={handleChange}
            placeholder="Marca, modelo, color"
          />
        </Grid>
        <Grid item style={{ marginBottom: 20 }}>
          <CategorySelect category={handleCategorySelected} removeChip />
        </Grid>
        <Grid item>
          <Button
            disabled={!searchProduct.length}
            className={classes.rightButton}
            onClick={() => handleSearchProducts()}
            variant="contained"
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Buscar producto
          </Button>
        </Grid>
      </Grid>
      {productFoundArray.length > 0 && (
        <>
          <Grid style={{ marginTop: theme.spacing(5) }}>
            {productFoundArray
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((product, i) => {
                return product.accesoryId ? (
                  <AccesoryCard key={i} product={product} />
                ) : (
                  <MovileCard key={i} product={product} />
                );
              })}
          </Grid>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={productFoundArray.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => {
              const { rowsPerPage, page } = changeRowsPerPage(event);
              setRowsPerPage(rowsPerPage);
              setPage(page);
            }}
          />
        </>
      )}

      {productsAvailable === false && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={productsAvailable === false}
        />
      )}
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
  addToCart: actions.addToCart,
  removeFromCart: actions.removeFromCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(ContainerNewSell);
